import { render } from "./About.vue?vue&type=template&id=09ea2efc&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=09ea2efc&lang=scss&scoped=true"

import exportComponent from "/Users/andreibratu/Projects/AlibPortfolio/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ea2efc"]])

export default __exports__